module.exports = __webpack_public_path__ + "img/batteri-ladeniveau-forside_hvid70.18623350.svg";